import React, {ComponentType} from "react";
import BadData from "./index";
import {IProps, IContainerProps, IServices, IHandlers, IBaseProps} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import {ThemeProvider} from "@material-ui/core/styles";
import ReactUtilsService from "app/services/reactUtils.service";

const NS = 'BadDataContainer';

const propsKeys: string[] = keys<IProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IContainerProps & IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {

  }

  return ReactUtilsService.containerWrap(
    <BadData {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ABadData: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
